<ng-select *ngIf="checkbox"
    [items]="options"
    bindValue="id"
    bindLabel="name"
    [multiple]="multi"
    [maxSelectedItems]="maxSelectedItems"
    [closeOnSelect]="false"
    [placeholder]="placeholder"
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)">
    <!-- <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
        <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.gender | uppercase}}
    </ng-template> -->
    <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.name}}
    </ng-template> -->
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <table>
            <tr>
                <td class="pl-1">
                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/>
                </td>
                <td class="pl-2">
                    <div *ngFor="let line of getLines(item.name)">{{line}}</div>
                </td>
            </tr>
        </table>
    </ng-template>
</ng-select>

<ng-select *ngIf="!checkbox"
    [items]="options"
    bindValue="id"
    bindLabel="name"
    [multiple]="multi"
    [maxSelectedItems]="maxSelectedItems"
    [placeholder]="placeholder"
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)">
</ng-select>